import { useMemo } from 'react';

import { ChipSelectOption } from '@components/ChipSelectOption/ChipSelectOption';
import { UNION_STATUS_OPTIONS } from '@lib/utils/constants/applicationConstants';
import { useJobsBoardFiltersModalContext } from '@views/jobsBoard/JobsBoardSection/JobsBoardFilters/JobsBoardFiltersModal/context';

import { FilterCollapse } from '../components/FilterCollapse';
import { StyledChipsContainer } from '../styles';

export const UnionStatusFilter = () => {
  const { modalFilters, toggleUnionStatus } = useJobsBoardFiltersModalContext();

  const subtitle = useMemo(() => {
    if (!modalFilters?.unionStatuses?.length) {
      return 'Any';
    }

    return (
      UNION_STATUS_OPTIONS.filter((unionStatus) =>
        modalFilters?.unionStatuses?.includes(unionStatus.value)
      )
        .map((unionStatus) => unionStatus.label)
        .join(', ') || 'Any'
    );
  }, [modalFilters?.unionStatuses]);

  return (
    <FilterCollapse
      title={'Union'}
      subtitle={subtitle}
      content={
        <UnionStatusFilterContent
          unionStatuses={modalFilters?.unionStatuses}
          toggleUnionStatus={toggleUnionStatus}
        />
      }
    />
  );
};

type UnionStatusFilterContentProps = {
  unionStatuses: string[] | undefined;
  toggleUnionStatus: (unionStatus: string) => void;
};
const UnionStatusFilterContent = ({
  unionStatuses,
  toggleUnionStatus,
}: UnionStatusFilterContentProps) => {
  return (
    <StyledChipsContainer applyMobileWidthReduction>
      {UNION_STATUS_OPTIONS.map((unionStatus) => (
        <ChipSelectOption
          key={`jobs-board-filter-union-status-${unionStatus.value}`}
          label={unionStatus.label}
          isSelected={unionStatuses?.includes(unionStatus.value) ?? false}
          onClick={() => toggleUnionStatus(unionStatus.value)}
        />
      ))}
    </StyledChipsContainer>
  );
};
